export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path fill="#7A9DFF" d="M6.782 15.75L1.474 9.833l1.032-1.166L6.782 13.5l8.183-9.333 1.032 1.166z" fillRule="nonzero" />
        </svg>
    );
}
